import React from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import { getFriendlyDate, getMyLocalTime } from "../../Utilities/Utilities.ts";
import UserCell from "../Tools/UserCell.tsx";

interface request {
  userId: any;
  tDate: string;
}

export function UserWithDateCell({ userId, tDate }: request) {
  const hasDate = !!tDate;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <UserCell
        userId={userId}
        exUI={
          hasDate ? (
            <div
              className="d-flex align-items-center gap-1 text-muted-theme"
              style={{ fontSize: '0.75rem' }}
              title={tDate}
            >
              <FaRegCalendarAlt />
              <span>{tDate}</span>
            </div>
          ) : null
        }
      />
    </div>
  );
}


export default UserWithDateCell;
